import { combineReducers } from '@reduxjs/toolkit'
import authSlice from './Auth/authSlice'
import hamSlice from './Ham/hamSlice'
import toasterSlice from './Toaster/toasterSlice'
import loaderSlice from './Loader/loaderSlice'
import playerSlice from './Players/playerSlice'
import transactionsSlice from './Transactions/transactionsSlice'
import gameSettingsSlice from './GameSettings/gameSettingsSlice'
import dashboardSlice from './Dashboard/dashboardSlice'
import gameTablesSlice from './GameTables/gameTablesSlice'
import gameTableSlice from './GameTables/gameTable.slice'
import userManagementSlice from './UserManagement/userManagementSlice'

export const rootReducer = combineReducers({
  auth: authSlice,
  ham: hamSlice,
  dashboard: dashboardSlice,
  toaster: toasterSlice,
  loader: loaderSlice,
  players: playerSlice,
  transactions: transactionsSlice,
  gameSettings: gameSettingsSlice,
  gameTables: gameTablesSlice,
  gameTable: gameTableSlice,
  userManagement: userManagementSlice
})
